<div *ngIf="selectArr" class="select-wrap">
  <div class="category" (click)="showHideObj = !showHideObj">
    <h3>
      {{ title | camelCase }}
      <button
        class="button remove-filter"
        (click)="clearFilter()"
        *ngIf="this.selectArrControl.value?.length"
      >
        {{ selectArrControl.value?.length }} &times;
      </button>
    </h3>
    <i class="icon-arrow" [ngClass]="{rotate: !showHideObj}"></i>
  </div>
  <div class="option-list" [style.display]="showHideObj ? 'block' : 'none'">
    <div *ngFor="let item of selectArr" class="option-div">
      <label class="label-check">
        <input
          class="check_input"
          type="checkbox"
          [(ngModel)]="selectedCheckboxes[item.name]"
          (change)="onChangeCheckbox(item, $event)"
        />
        <span class="check_box"></span>
        {{ item.name }}
      </label>
    </div>
  </div>
</div>
